import type { UseFormReturn } from 'react-hook-form';
import { Box } from '@mui/material';
import { Accordion, RhfSelect } from '@core/components';
import { ChasubleBodyFabricFields } from '../../../components/ChasubleValueFields';
import type { VestmentType } from '../../../enum/vestmentType';
import {
  BODY_TYPE_OPTIONS,
  getChasubleFeatures,
  hasChasubleSleeveDesign,
} from '../../../utils/chasuble';
import type {
  ChasubleItemFormValues,
  OrderItemDialogSlotProps,
} from '../../../utils/orderItem';
import { CollapsibleField } from '../CollapsibleField';
import { RhfDesignPicker } from '../RhfDesignPicker';

interface BodySectionProps {
  methods: UseFormReturn<ChasubleItemFormValues>;
  vestmentType?: VestmentType;
  setPreviewTab: OrderItemDialogSlotProps<ChasubleItemFormValues>['setPreviewTab'];
  expanded: boolean;
  onChange: (expanded: boolean) => void;
}

export function BodySection({
  methods,
  vestmentType,
  setPreviewTab,
  expanded,
  onChange,
}: BodySectionProps) {
  const bodyType = methods.watch('bodyType');

  return (
    <Accordion title="Body" expanded={expanded} onChange={onChange}>
      {getChasubleFeatures(vestmentType)?.bodyType ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 2,
          }}
        >
          <RhfSelect<ChasubleItemFormValues>
            name="bodyType"
            label="Type"
            options={BODY_TYPE_OPTIONS}
            onValueChange={(value) => {
              if (value === bodyType) {
                return;
              }
              methods.setValue('design', null, { shouldDirty: true });
              methods.setValue('designCode', '', { shouldDirty: true });
            }}
          />
          <CollapsibleField
            collapsed={!hasChasubleSleeveDesign(vestmentType, bodyType)}
          >
            <RhfDesignPicker
              key={vestmentType}
              vestmentType={vestmentType}
              onValueChange={() => setPreviewTab('design')}
            />
          </CollapsibleField>
        </Box>
      ) : null}
      <ChasubleBodyFabricFields<ChasubleItemFormValues> />
    </Accordion>
  );
}
